import { createSlice } from "@reduxjs/toolkit";

export interface Lga {
  id: number;
  name: string;
  stateId?: number;
}

export interface State {
  id: number;
  name: string;
  lgas?: Lga[];
}

export interface LocationState {
  states: State[];
  lgas: Lga[];
  selectedState: State | null;
  selectedLga: Lga | null;
  loading: boolean;
  error: string | null;
}

const initialState: LocationState = {
  states: [],
  lgas: [],
  selectedState: null,
  selectedLga: null,
  loading: false,
  error: null,
};
const locationSlice = createSlice({
  name: "location",
  initialState,

  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
      state.error = null;
    },
    setStates(state, action) {
      state.states = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLgas(state, action) {
      state.lgas = action.payload;
      state.loading = false;
      state.error = null;
    },
    setError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedState(state, action) {
      state.selectedState = action.payload;
      state.selectedLga = null;
      state.lgas = [];
    },
    setSelectedLga(state, action) {
      state.selectedLga = action.payload;
    },
    resetLocation(state) {
      state.selectedState = null;
      state.selectedLga = null;
      state.lgas = [];
      state.error = null;
      state.loading = false;
    },
  },
});

export const locationActions = locationSlice.actions;

export default locationSlice;
